import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"

import { Select } from "components"
import { getCoupens } from "services"

const CouponsSelect = (props) => {
  const {
    className,
    onChange,
    value,
    error,
    isMulti = false,
    isClearable = false,
    label,
    placeholder,
    queries = {},
    ...otherProps
  } = props

  const [t] = useTranslation()

  const [couponSelectDefaultOptions, setCouponSelectDefaultOptions] = useState(null)
  const queriesKey = JSON.stringify(queries || {})

  const timeout = useRef()
  const unmount = useRef(false)

  const handleFocus = async () => {
    if (couponSelectDefaultOptions !== null) return

    const response = await getCoupens({ type: "basic", ...queries, limit: 5 })

    if (unmount.current) return

    setCouponSelectDefaultOptions(
      response.map(c => ({
        label: c.code,
        value: c.code,
        data: c
      }))
    )
  }

  const handleSearchCoupons = (inputValue, callback) => {
    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(async () => {
        const requestQueries = {
          type: "basic",
          ...queries,
          code: inputValue.trim(),
          limit: 5
        }

        const response = await getCoupens(requestQueries)

        if (unmount.current) return

        callback(
          response.map(c => ({
            label: c.code,
            value: c.code,
            data: c
          }))
        )
      }, 600)
  }

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true

      clearTimeout(timeout.current)
    }
  }, [])

  useEffect(() => {
    setCouponSelectDefaultOptions(null)
  }, [queriesKey])

  return (
    <Select
      async
      isMulti={isMulti}
      isClearable={isClearable}
      noOptionsMessage={() => null}
      label={label || t("کد_کوپن")}
      placeholder={placeholder || t("کد_کوپن_خود_را_جست_و_جو_کنید")}
      loadOptions={handleSearchCoupons}
      className={className}
      onChange={onChange}
      value={value}
      defaultOptions={couponSelectDefaultOptions}
      onFocus={handleFocus}
      error={error}
      {...otherProps}
    />
  )
}

export default CouponsSelect
